document.addEventListener("DOMContentLoaded", function() {
  var video = document.getElementById('backgroundVideo');
  var options = {
    root: null, // Usa o viewport como área de visualização para checagem
    rootMargin: '0px',
    threshold: 0.5 // Dispara quando 50% do vídeo estiver visível
  };

  var observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        video.play();
      } else {
        video.pause();
      }
    });
  }, options);

  observer.observe(video);
});
